import { FC } from 'react'

import { useMutation } from '@tanstack/react-query'
import { Link, getRouteApi, useRouter } from '@tanstack/react-router'
import { routes } from 'commons/constants/routes'
import { Request } from 'commons/utils/request'
import { ButtonGroup, IconName } from 'ui/components'
import { Button, IconButton } from 'ui/components/Buttons'
import { useDeleteSalesDepositConfirmation } from '~bank-annual-review/hooks'
import { SalesDepositItem } from '~bank-annual-review/types/AnnualReviewDetails'

import { handlerServerError } from '@orbit/errors'

export const Actions: FC<SalesDepositItem> = ({ enableRecalculate, id: salesAndDepositId }) => {
  const { id: annualReviewId } = getRouteApi('/_app/annual-review/detail/$companyId/$id').useParams()
  const { DeleteConfirmation, openDeleteSalesDepositConfirmation } = useDeleteSalesDepositConfirmation({})
  const router = useRouter()

  const { mutate: recalculateSalesDeposit } = useMutation<void, Error, { id: number }>({
    mutationFn: ({ id }) => Request.put(Request.urls.bank.annualReviewSalesDepositsRecalculation, { id }),
    onSuccess: async () => {
      router.invalidate()
    },
    onError: (error) => handlerServerError(error)
  })

  return (
    <>
      <DeleteConfirmation />
      <ButtonGroup margin="big">
        <IconButton
          face="negative"
          icon={IconName.DELETE}
          onClick={() => openDeleteSalesDepositConfirmation(Number(salesAndDepositId))}
        >
          Delete
        </IconButton>
        <Link
          to={routes.bank.annualReview.salesDeposits}
          params={{
            annualReviewId: annualReviewId.toString(),
            id: salesAndDepositId.toString()
          }}
        >
          <Button face="primary">Edit</Button>
        </Link>
        {enableRecalculate && (
          <Button face="primary" onClick={() => recalculateSalesDeposit({ id: salesAndDepositId })}>
            Recalculate
          </Button>
        )}
      </ButtonGroup>
    </>
  )
}
